module.exports = __webpack_public_path__ + "static/media/target-audience.5b907153.png";